import { render, staticRenderFns } from "./articleManage.vue?vue&type=template&id=93f67c96&scoped=true"
import script from "./articleManage.vue?vue&type=script&lang=js"
export * from "./articleManage.vue?vue&type=script&lang=js"
import style0 from "./articleManage.vue?vue&type=style&index=0&id=93f67c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f67c96",
  null
  
)

export default component.exports